"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adaptTranslations = void 0;
var _locale = require("../../../utils/locale");
const adaptTranslations = translations => {
  const adaptedTranslations = Object.fromEntries(_locale.supportedLocales.map(supportedLocale => [supportedLocale, {}]));
  translations.forEach(_ref => {
    let {
      code,
      ...translation
    } = _ref;
    _locale.supportedLocales.forEach(supportedLocale => {
      const translationValue = translation[supportedLocale];
      if (!translationValue) {
        return;
      }
      adaptedTranslations[supportedLocale][code] = translationValue;
    });
  });
  return adaptedTranslations;
};
exports.adaptTranslations = adaptTranslations;